import React from "react"

import { createTheme, ThemeProvider } from "@mui/material/styles"
import CssBaseline from "@mui/material/CssBaseline"
import { GlobalStyles } from "@mui/material"

const theme = createTheme({
	palette: {
		primary: {
			main: "#465578"
		},

		secondary: {
			main: "#6c63ff"
		}
	},

	typography: {
		h2: {
			marginBottom: "25px",
			fontSize: "36px",
			fontWeight: 600,
			lineHeight: 1.4,

			"@media (max-width:1024px)": {
				marginBottom: "20px",
				fontSize: "24px"
			},

			"@media (max-width:767px)": {
				marginBottom: "15px",
				fontSize: "22px",
				lineHeight: 1.3
			}
		},

		h3: {
			marginBottom: "25px",
			maxWidth: "800px",
			fontSize: "20px",
			fontWeight: 600,
			lineHeight: 1.2,

			"@media (max-width:1024px)": {
				fontSize: "14px"
			},

			"@media (max-width:767px)": {
				marginBottom: "20px",
				lineHeight: 1.3
			}
		},

		h4: {
			marginBottom: "20px",
			fontSize: "16px",
			fontWeight: 600,

			"@media (max-width:767px)": {
				fontSize: "14px"
			}
		},

		body1: {
			fontSize: "16px",

			"@media (max-width:1024px)": {
				fontSize: "14px"
			}
		},

		body2: {
			marginBottom: "8px",
			fontSize: "12px"
		}
	},

	components: {
		MuiTable: {
			styleOverrides: {
				root: {
					marginBottom: "20px",
					width: "100%",
					borderCollapse: "collapse"
				}
			}
		},

		MuiTableCell: {
			styleOverrides: {
				root: {
					padding: "10px 0",
					minWidth: "50%",
					width: "50%",
					fontSize: "14px",
					color: "#465578",
					borderBottom: "1px solid #acbee8",

					"&:first-of-type": {
						fontWeight: "600"
					},

					"&:last-of-type": {
						textAlign: "right"
					},

					"@media(max-width: 1024px)": {
						fontSize: "12px"
					}
				}
			}
		},

		MuiListItem: {
			styleOverrides: {
				root: {
					display: "block"
				}
			}
		},

		MuiButton: {
			styleOverrides: {
				root: {
					padding: "13px 35px",
					display: "flex",
					alignItems: "center",
					justifyContent: "center",
					fontSize: "16px",
					fontWeight: "600",
					lineHeight: "unset",
					textTransform: "none",
					borderRadius: "5px !important",
					boxShadow: "none !important",
					transition: "all .3s ease",

					"@media(max-width: 767px)": {
						padding: "10px 30px",
						minWidth: "auto",
						minHeight: "45px"
					}
				},

				contained: {
					minWidth: "108px",
					color: "#fff",
					border: "none",
					backgroundColor: "transparent !important",
					backgroundImage: "linear-gradient(78deg, #7fc2ff 14.97%, #6c63ff 81.1%)",
					backgroundSize: "140% auto",
					backgroundPosition: "left center !important",

					"&:hover": {
						backgroundPosition: "right center !important"
					}
				},

				outlined: {
					border: "1px solid #acbee8 !important",
					background: "transparent",

					"&:hover": {
						opacity: ".6"
					}
				},

				text: {
					color: "#fff",
					background: "#7fc2ff",
					border: "1px solid #7fc2ff",

					"&:hover": {
						color: "#7fc2ff",
						backgroundColor: "transparent"
					}
				}
			},

			defaultProps: {
				disableElevation: true
			}
		}
	}
})

export default function Theme({ children }) {
	return (
		<ThemeProvider theme={theme}>
			<CssBaseline />

			<GlobalStyles
				styles={{
					"*": {
						margin: 0,
						padding: 0,
						color: theme.palette.primary.main,
						fontFamily: "Poppins, sans-serif !important"
					},

					a: {
						textDecoration: "none",
						transition: "all 0.2s ease"
					},

					li: {
						margin: "0px 0px 10px 30px !important"
					},

					img: {
						maxWidth: "100%"
					},

					"& input": {
						appearance: "textfield",
						MozAppearance: "textfield",
						"::-ms-clear": { display: "none" },
						"::-webkit-inner-spin-button": { display: "none" },
						"::-webkit-outer-spin-button": { display: "none" }
					},

					"& select": {
						backgroundImage: `url(/assets/images/onboarding/select-arrow.svg)`,
						backgroundRepeat: "no-repeat",
						backgroundPositionX: "95%",
						backgroundPositionY: "50%",
						WebkitAppearance: "none",
						MozAppearance: "none"
					},

					"& input, & select": {
						paddingLeft: "17px !important",
						width: "100%",
						height: "50px",
						fontSize: "14px",
						color: "#465578",
						outline: "none",
						border: "1px solid #acbee8",
						borderRadius: "5px",

						"@media (max-width: 767px)": {
							height: "45px",
							fontSize: "14px"
						}
					},

					"& input::placeholder, & select:invalid": {
						color: "#bbd3eb !important"
					}
				}}
			/>
			{children}
		</ThemeProvider>
	)
}
